import { createUrl } from "@mne-core/api";
export const transformUrlOpenApi = (apiUrl, module) => createUrl(apiUrl, [module, "/openapi.json"]).toString();
